// extracted by mini-css-extract-plugin
export default {"nav-icon":"nav-icon__yNBoL","navIcon":"nav-icon__yNBoL","icon-pp":"icon-pp__2k+fN","iconPp":"icon-pp__2k+fN"};